// extracted by mini-css-extract-plugin
export var container = "_2g-0";
export var disabled = "_2g-3";
export var enabled = "_2g-2";
export var statusLight = "_2g-1";